import { useAppSelector } from '../../store/hooks';
import { initState } from '../../store/reducers/cms.reducer';
import { CMS_ITEM_NAME } from '../../utils/cms/cms-item-names';
import { SocialProof } from './SocialProof';

type SocialProofContainerProps = {
  lightTheme?: boolean;
};

export const SocialProofContainer = ({ lightTheme }: SocialProofContainerProps) => {
  const statistics = useAppSelector(({ cms }) => {
    return cms[CMS_ITEM_NAME.DYNAMIC_STATISTICS]?.statistics || initState[CMS_ITEM_NAME.DYNAMIC_STATISTICS]?.statistics;
  });

  const socialProfProps = {
    lightTheme,
    statistics,
  };

  return <SocialProof {...socialProfProps} />;
};
